import React from 'react';
import { supporters } from '../constants/supporters';

const SupportersSection = () => {
  return (
    <div id="supporters" className="container mx-auto px-4 sm:px-6 pt-6 pb-6 sm:py-16 relative z-10">
      <div className="glass-section">
        <h2 className="text-3xl lg:text-4xl font-bold mb-3 drop-shadow-xl text-center font-display text-white">
          Our Supporters
        </h2>
        <p className="text-white/70 text-center text-base mb-8">
          We're grateful to the following organizations and businesses for their generous support.
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {supporters.map((name) => (
            <div
              key={name}
              className="bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-center text-white text-sm font-medium hover:bg-white/20 transition-all duration-200"
            >
              {name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SupportersSection;
